import { render, staticRenderFns } from "./Prohot.vue?vue&type=template&id=58f16e6e&scoped=true&"
import script from "./Prohot.vue?vue&type=script&lang=js&"
export * from "./Prohot.vue?vue&type=script&lang=js&"
import style0 from "./Prohot.vue?vue&type=style&index=0&id=58f16e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f16e6e",
  null
  
)

export default component.exports